import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import SubscribeSuccess from './successScreens/paySuccess';
import HomeScreen from '../screen/HomeScreen';
import PrivacyPolicy from '../screen/privacyPolicy';
import TermsOfUse from '../screen/termsOfUse';
import Page1 from '../quiz/page1';
import Page2 from '../quiz/page2';
import Page3 from '../quiz/page3';
import Page4 from '../quiz/page4';
import Page5 from '../quiz/page5';
import Page6 from '../quiz/page6';
import Page7 from '../quiz/page7';
import Page8 from '../quiz/page8';
import Page9 from '../quiz/page9';
import Page10 from '../quiz/page10';
import Page11 from '../quiz/page11';
import Page12 from '../quiz/page12';
import Page13 from '../quiz/page13';
import Page14 from '../quiz/page14';
import Page15 from '../quiz/page15';
import Page16 from '../quiz/page16';
import Page17 from '../quiz/page17';
import Page18 from '../quiz/page18';
import Page19 from '../quiz/page19';
import Page20 from '../quiz/page20';
import Page21 from '../quiz/page21';
import Page22 from '../quiz/page22';
import Page23 from '../quiz/page23';
import Page24 from '../quiz/page24';
import Page25 from '../quiz/page25';
import Page26 from '../quiz/page26';
import Page27 from '../quiz/page27';
import Page28 from '../quiz/page28';
import Page29 from '../quiz/page29';
import Page30 from '../quiz/page30';
import Page31 from '../quiz/page31';
import Page32 from '../quiz/page32';
import Page33 from '../quiz/page33';
import Page34 from '../quiz/page34';
import Page35 from '../quiz/page35';
import Page36 from '../quiz/page36';
import LoadingScreen from '../quiz/loading';
import IdentifyingScreen from '../quiz/identifying';
import TreatmentScreen from '../quiz/treatment';
import PredictionScreen from '../quiz/prediction';
import AnalyzeScreen from '../quiz/analyze';
import DeleteAccountScreen from '../screen/deleteScreen';
import DeleteSuccess from './successScreens/successDelete';
import ContactScreen from '../screen/contactScreen';
import SuccessContact from './successScreens/successContact';
import KeepResults from '../quiz/keepResults';
import RefundPolicy from '../screen/RefundPolicy';
import LoadingScreen2 from '../quiz/loading2';
import LoadingScreen3 from '../quiz/loading3';
import LoadingScreen4 from '../quiz/loading4';
import LoadingScreen5 from '../quiz/loading5';


const AppContent = () => {
  const location = useLocation();

  return (
        <AnimatePresence mode="wait">
    <Routes location={location} key={location.pathname}>
            <Route path="/" element={<HomeScreen />} />
      <Route path="/loading" element={<LoadingScreen />} />
      <Route path="/loading-2" element={<LoadingScreen2 />} />
      <Route path="/loading-3" element={<LoadingScreen3 />} />
      <Route path="/loading-4" element={<LoadingScreen4 />} />
      <Route path="/loading-5" element={<LoadingScreen5 />} />
            <Route path="/analyze" element={<AnalyzeScreen />} />
            <Route path="/identify" element={<IdentifyingScreen />} />
            <Route path="/treatment" element={<TreatmentScreen />} />
            <Route path="/prediction" element={<PredictionScreen />} />   
            <Route path="/privacy-policy" element={<PrivacyPolicy />} /> 
            <Route path="/terms-of-use" element={<TermsOfUse />} /> 
            <Route path="/refund-policy" element={<RefundPolicy />} />
        <Route path="/quiz1" element={<Page1 />} />
        <Route path="/quiz2" element={<Page2 />} />
        <Route path="/quiz3" element={<Page3 />} />
        <Route path="/quiz4" element={<Page4 />} />
        <Route path="/quiz5" element={<Page5 />} />
        <Route path="/quiz6" element={<Page6 />} />
        <Route path="/quiz7" element={<Page7 />} />
        <Route path="/quiz8" element={<Page8 />} />
        <Route path="/quiz9" element={<Page9 />} />
        <Route path="/quiz10" element={<Page10 />} />
        <Route path="/quiz11" element={<Page11 />} />
        <Route path="/quiz12" element={<Page12 />} />
        <Route path="/quiz13" element={<Page13 />} />
        <Route path="/quiz14" element={<Page14 />} />
        <Route path="/quiz15" element={<Page15 />} />
        <Route path="/quiz16" element={<Page16 />} />
        <Route path="/quiz17" element={<Page17 />} />
        <Route path="/quiz18" element={<Page18 />} />
        <Route path="/quiz19" element={<Page19 />} />
        <Route path="/quiz20" element={<Page20 />} />
        <Route path="/quiz21" element={<Page21 />} />
        <Route path="/quiz22" element={<Page22 />} />
        <Route path="/quiz23" element={<Page23 />} />
        <Route path="/quiz24" element={<Page24 />} />
        <Route path="/quiz25" element={<Page25 />} />
        <Route path="/quiz26" element={<Page26 />} />
        <Route path="/quiz27" element={<Page27 />} />
        <Route path="/quiz28" element={<Page28 />} />
        <Route path="/quiz29" element={<Page29 />} />
        <Route path="/quiz30" element={<Page30 />} />
        <Route path="/quiz31" element={<Page31 />} />
        <Route path="/quiz32" element={<Page32 />} />
        <Route path="/quiz33" element={<Page33 />} />
        <Route path="/quiz34" element={<Page34 />} />
        <Route path="/quiz35" element={<Page35 />} />
        <Route path="/quiz36" element={<Page36 />} />
        <Route path="/keep-results" element={<KeepResults />} />
        <Route path="/prediction/subscribe-success" element={<SubscribeSuccess />} />
         <Route path="/home" element={<HomeScreen />} />
          <Route path="/delete" element={<DeleteAccountScreen />} />
           <Route path="/delete/success" element={<DeleteSuccess />} />
           <Route path="/contact-us" element={<ContactScreen />} />
           <Route path="/contact-us/success" element={<SuccessContact />} />
      </Routes>
    </AnimatePresence>
  );
};

export default AppContent;
